<template>
  <b-modal
    :active="active"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
    :can-cancel="false"
  >
    <form
      @submit.prevent="$emit('submit')"
    >
      <div
        class="modal-card h-1/2"
      >
        <header
          v-if="title"
          class="modal-card-head"
        >
          <p class="modal-card-title">
            {{ title }}
          </p>
        </header>

        <section class="modal-card-body">
          <slot name="body" />
        </section>

        <footer class="modal-card-foot">
          <slot name="footer" />
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    title: {
      type: String,
      default: undefined,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
